export default __webpack_public_path__ + "static/media/home-decor-img-11.4ab884e7.png";